import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ConsentBanner } from '../ConsentBanner';
import { Concierge } from '../Concierge';
import { track } from '../../lib/analytics';
export function SiteLayout() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    track('page_view', {
      path: location.pathname,
      referrer: document.referrer
    });
  }, [location.pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-210" data-mp="3i0d73jupvs7o">
      <Header data-id="element-211" data-mp="ik6u4xzkyjz" />
      <main id="main" className="flex-1" data-id="element-212" data-mp="j3n7h7znevw">
        <Outlet data-id="element-213" data-mp="k50lsch8dgs" />
      </main>
      <Footer data-id="element-214" data-mp="3rxhu1lwdzrpj" />
      <Concierge data-id="element-215" data-mp="3rwzm3s0d3p1s" />
      <ConsentBanner data-id="element-216" data-mp="3rwgfh7g5wn32" />
    </div>;
}